import { useNavigate } from 'react-router-dom';
import { Mail, Phone, MapPin, Globe } from 'lucide-react';
import Logo from './Logo';

export default function Footer() {
  const navigate = useNavigate();

  const scrollOrNavigate = (id) => {
    if (window.location.pathname === '/') {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/#' + id);
    }
  };

  return (
    <footer className="bg-[#060D1F] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-10 pb-12 border-b border-white/10">
          <div className="md:col-span-1">
            <button onClick={() => navigate('/')}><Logo size="md" /></button>
            <p className="text-slate-400 text-sm mt-4 leading-relaxed">
              Innovating the future with smart tech solutions. Your trusted partner in digital transformation.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              {['home', 'about', 'services', 'contact'].map((l) => (
                <li key={l}>
                  <button
                    onClick={() => scrollOrNavigate(l)}
                    className="hover:text-orange-400 transition-colors capitalize"
                  >
                    {l}
                  </button>
                </li>
              ))}
              <li>
                <button onClick={() => navigate('/projects')} className="hover:text-orange-400 transition-colors">
                  Projects
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4">Programs</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><button onClick={() => navigate('/internships')} className="hover:text-orange-400 transition-colors">Internships</button></li>
              <li><button onClick={() => navigate('/campus2training')} className="hover:text-orange-400 transition-colors">Campus2Training</button></li>
              <li><span className="text-slate-500">Industrial Training</span></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li className="flex gap-2 items-start"><Mail className="w-4 h-4 flex-shrink-0 mt-0.5" /> officecalloc@gmail.com</li>
              <li className="flex gap-2 items-start"><Phone className="w-4 h-4 flex-shrink-0 mt-0.5" /> +91 8971504091</li>
              <li className="flex gap-2 items-start"><MapPin className="w-4 h-4 flex-shrink-0 mt-0.5" /> Mysore, Karnataka</li>
              <li className="flex gap-2 items-start"><Globe className="w-4 h-4 flex-shrink-0 mt-0.5" /> www.calloctech.com</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-8 text-sm text-slate-500">
          <p>© 2025 CALLOC Technologies Private Limited. All rights reserved.</p>
          <div className="flex gap-6">
            <button onClick={() => navigate('/privacy-policy')} className="hover:text-orange-400 transition-colors">Privacy Policy</button>
            <button onClick={() => navigate('/account-deletion')} className="hover:text-orange-400 transition-colors">Delete Account</button>
          </div>
        </div>
      </div>
    </footer>
  );
}
